import styled from 'styled-components';
import { device } from "../device";

const Button = styled.button`
    position: relative;

    align-items: center;
    display: flex;
    height: 32px;
    justify-content: center;
    padding: 0 24px;
    width: fit-content;

    background: var(--green1);
    color: var(--brand);
    border: 0;
    border-radius: 24px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    line-height: 1px;
    outline: 0;
    transition: background .1s ease-in-out;
    &:hover {
        background: var(--green2);
        color: var(--brand);
    }
    @media ${device.lg} {
        padding: 0 32px;
    }
`;

export default Button;